import { useOneChanceState } from "app/one-chance/useOneChance";
import { ONE_CHANCE_SETTINGS } from "app/data/game-settings";

// Returns the number of cost of revealing the next level, or -1 if the max
// number of reveals has been exceeded.
export default function useLetterRevealCost(): number {
  const {
    letterRevealMultCost,
    letterRevealMultCostIncrease,
    maxLetterReveals,
  } = ONE_CHANCE_SETTINGS;

  const roundState = useOneChanceState();

  if (roundState.revealsUsed >= maxLetterReveals) {
    return -1;
  }

  const cost =
    letterRevealMultCost +
    letterRevealMultCostIncrease * roundState.revealsUsed;
  
  return parseFloat(cost.toFixed(1));
}
